<template>
    <div>
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">{{ $t("products") }}</h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-breadcrumb />
                    </nav>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--6">
            <validation-observer ref="formValidator">
                <form class="new-event--form">
                    <div class="card mb-4">
                        <!-- Card header -->
                        <div class="card-header"><h3 class="mb-0">{{ $t("products") }}</h3></div>
						 <!-- Card body -->
                        <div class="card-body">
                            <!-- Form groups used in grid -->
                            <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('name')" :name="$t('name')" v-model="params.name" rules="required" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('product_code')" :name="$t('product_code')" v-model="params.code" rules="required" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('tag')" :name="$t('tag')" v-model="params.tag" rules="required" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('product_category')">
                                        <el-select v-model=" params.bo_product_category_id " :name="$t('product_category')" :placeholder=" $t('product_category') " filterable >
                                            <el-option v-for="option in ProductCategoryTable" :key="option.id" :label="option.name" :value="option.id" > </el-option>
                                        </el-select>
                                    </base-input>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('detail')">
                                        <textarea class="form-control" rows="3" v-model="params.detail" ></textarea>
                                    </base-input>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('price')" :name="$t('price')" v-model.number="params.price" rules="required|numeric" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('shipping_cost')" :name="$t('shipping_cost')" v-model.number="params.shopping_cost" rules="required|numeric" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('status')">
                                        <el-select
                                            v-model="params.status"
                                            :name="$t('status')"
                                            :placeholder="$t('status')"
                                            filterable
                                        >
                                            <el-option
                                                v-for="option in ProductStatusTable"
                                                :key="option.id"
                                                :label="option.name"
                                                :value="option.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input :label="$t('image')" :name="$t('image')" >
                                        <file-input rules="required" @change="filesChange" ></file-input>
                                    </base-input>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
									<img :src="GetProductUrl(params.images)" height="200px" v-if="params.images.includes('.png') || params.images.includes('.jpg') || params.images.includes('jpeg')"/>
                                    <img v-if="!params.images.includes('.png') && !params.images.includes('.jpg') && !params.images.includes('jpeg')  && params.images != '' && params.images != null && params.images != undefined " :src="params.images" height="200px" />
                                </div>
                            </div>

							<!-- Variable -->
                            <div class="row py-4">
                                <div class="col-md-1 pb-3">
                                    Variable
                                </div>
                                <div class="col-md-6">
                                    <base-button size="sm" v-if="attributes.length <= 15" @click="handleAddVariable()" >Add Variable</base-button >
                                </div>
                            </div>

                            <!-- Is Comboset Checkbox (only show when exactly 1 variable) -->
                            <div class="row py-2" v-if="attributes.length === 1">
                                <div class="col-md-6">
                                    <base-checkbox v-model="params.is_comboset">
                                        {{ $t('is_comboset') }}
                                    </base-checkbox>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div v-for="(attribute, index) in attributes" :key="index" class="row py-2" >
                                        <div class="col-md-6 col-lg-3">
                                            <base-input v-model="attribute.variable" size="sm"/>
                                        </div>

                                        <div class="col-md-6 col-lg-3">
                                            <base-button @click=" handleRemoveVariable(index) " type="danger" >
												 <i class="fa fa-trash"></i>
											</base-button>
                                            <base-button v-if="attributes.length < 12" @click=" handleCopyVariable( index) " type="primary" > <i class="fa fa-file"></i ></base-button>
                                            <base-button @click="handleManageOption(attribute)" type="primary">
                                                <i class="fa fa-plus"></i>
											</base-button>
                                        </div>

                                        <div class="col-md-12 col-lg-12">
											<template v-for="(option, index) in attribute.options" >
												<span class="badge badge-pill badge-primary text-white mr-2 py-2 pb-2" v-if="option.wms_map[0].wms_product_id != 0" :key="index">
													{{ option.name }}
												</span>
												<span class="badge badge-pill badge-primary text-orange mr-2 py-2 pb-2" v-if="option.wms_map[0].wms_product_id == 0" :key="index">
													{{ option.name }}
												</span>
											</template>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <hr />
                            <div class="row">
                                <div class="col-md-12">
                                    <base-button @click="handleSaveProduct()" type="primary" >{{ $t("save") }}</base-button >
									<base-button size="md" type="secondary" @click="$router.go(-1)">{{ $t("back") }}</base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </div>

		<!-- Variable Modal -->
        <modal :show.sync="showAddVariable" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
					<div class="col md-3">
						<base-input :label="$t('name')" v-model="variableName"></base-input>
					</div>
            </form>

            <template slot="footer">
                <button type="submit" class="btn btn-md btn-primary" @click="handleUpdateVariable()" > {{ $t("add") }} </button>
                <button type="button" class="btn btn-md btn-link ml-auto" @click="showAddVariable = false" > {{ $t("close") }} </button>
            </template>
        </modal>

		<!-- Option Modal	-->
        <modal :show.sync="showManageOption" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
                <label for="">Variable : {{ attr.variable }}</label>
                <div class="row pb-3">
					<div class="col-md-10">
                        <base-input>
                            <el-select v-model="wms_product_id" :placeholder="$t('product')" :label="$t('product')" filterable @change="handleWmsMapChange">
                                <el-option v-for="option in WmsProductTable" :key="option.ID" :label="option.Name" :value="option.ID"/>
                            </el-select>
                        </base-input>
                    </div>

                    <div class="col-md-2">
                        <base-button size="md" @click="handleAddOption()" type="primary" > <i class="fa fa-plus"></i ></base-button>
                    </div>
                </div>

                <div class="row pb-3">
					<div class="col-md-10">
						<base-input>
							<el-select v-model="bo_product_random" value-key="id"  :placeholder="$t('product_random')" :label="$t('product_random')" filterable>
								<el-option v-for="(option,index) in SkuRandomTable"  :key="index" :label="option.name" :value="option"/>
							</el-select>
						</base-input>
					</div>

					<div class="col-md-2">
						<base-button size="md" @click="handleAddRandomOption()" type="primary" > <i class="fa fa-plus"></i ></base-button>
					</div>
				</div>

				<!-- option (wms) -->
				<div class="row py-2" v-for="(option,index) in attr.options" :key="index">
					<div class="col-md-10">
						{{ option.name }}
					</div>
					<div class="col-md-2">
						<base-button size="md" @click="handleRemoveOption(attr.options,index)" type="danger" > <i class="fa fa-trash"></i ></base-button>
					</div>
				</div>

            </form>

            <template slot="footer">
                <button type="button" class="btn btn-md btn-link ml-auto" @click="showManageOption = false" >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>

        <modal :show.sync="showMapWms" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
                <label for="">WMS Map</label>

                <div class="row pb-3">
                    <div class="col-md-7">
                        <base-input>
                            <el-select v-model="wms_product_id" :placeholder="$t('product')" :label="$t('product')" filterable >
                                <el-option v-for="option in WmsProductTable" :key="option.ID" :label="option.Name" :value="option.ID" > </el-option>
                            </el-select>
                        </base-input>
                    </div>
                    <div class="col-md-3">
                        <base-input :placeholder="$t('quantity')" v-model="quantity" > </base-input>
                    </div>
                    <div class="col-md-2">
                        <base-button size="md" @click="handleAddWmsProduct()" type="primary" ><i class="fa fa-plus"></i></base-button>
                    </div>
                </div>

                <div class="row">
                    <div
                        class="col-md-10"
                        v-if="products_sku[product_sku_index] != undefined"
                    >
                        <div
                            v-for="(option, index) in products_sku[
                                product_sku_index
                            ].wms_map"
                            :key="index"
                            class="row"
                        >
                            <div class="col-md-10 pb-3">
                                {{ GetProductName(option.wms_product_id) }} -
                                {{ option.pickup_quantity }}
                            </div>
                            <div class="col-md-2">
                                <base-button
                                    size="sm"
                                    @click="handleRemoveWmsProduct(index)"
                                    type="danger"
                                >
                                    <i class="fa fa-trash"></i
                                ></base-button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <template slot="footer">
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showMapWms = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>
    </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import FileInput from "@/components/Inputs/FileInput";
import { mapGetters, mapActions } from "vuex";
import swal from "sweetalert2";

export default {
    name: "form-elements",
    components: {
        FileInput,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    data() {
        return {
            showAddVariable: false,
            showManageOption: false,
            showMapWms: false,
            variableName: "",
            attr: [],
            attr_option: {
				name: "",
				wms_map: []
			},
            products_sku: [],
            params: {
                id: 0,
                name: "",
                detail: "",
                price: "",
                images: "",
                code: "",
                attributes: "",
                tag: "",
                status: "",
                bo_product_category_id: 1,
                products_sku: null,
				platform_product_id:"",
				platform_id:1,
				shipping_cost:0,
                is_comboset: false

            },
            attributes: [],
            sku: {},
            selectedWmsProduct: 0,
            wms_product_id: "",
            bo_product_random: "",
            quantity: "",
            product_sku_index: 0,
            inputs: {
                file: []
            },
            ProductStatusTable: [
                { id: 1, name: "ใช้งาน" },
                { id: 2, name: "ไม่ใช้งาน" }
            ],
            sku_file_index: 0
        };
    },
    computed: {
        ...mapGetters({
            WmsProductTable: "WmsProduct/getData",
            SkuRandomTable: "Product/getDataSkuRandom",
            ProductCategoryTable: "ProductCategory/getData"
        })
    },
    mounted() {
		// Clear Class
		let documentClasses = document.body.classList;
		console.log("Class : ",documentClasses)
		documentClasses.remove("modal-open");

		this.listSkuRandom();
        this.listWMS();
        this.listProductCategory();
        console.log("Param : " , this.$route.params);
        if (this.$route.params.params == undefined) {
            console.log("create ");
            // Create
        } else {
            let p = this.params.params;
            console.log("update" + this.$route.params.params.id);
            //  update
            this.params.id = this.$route.params.params.id;
            this.params.name = this.$route.params.params.name;
            this.params.detail = this.$route.params.params.detail;
            this.params.price = this.$route.params.params.price;
            this.params.images = this.$route.params.params.images;
            this.params.code = this.$route.params.params.code;
            this.params.shipping_cost = this.$route.params.params.shipping_cost;

			try {

            this.params.attributes = JSON.parse(
                this.$route.params.params.attributes
            );
            this.attributes = JSON.parse(this.$route.params.params.attributes);

			} catch (error) {
				console.log(error);
				this.attributes = []
				this.params.attributes = []
			}

            if (this.attributes == null) {
                this.attributes = [];
            }
            // check attributes is empty object
            if (
                Object.keys(this.attributes).length === 0 &&
                this.attributes.constructor === Object
            ) {
                this.attributes = [];
            }

            console.log(this.attributes);

            this.params.tag = this.$route.params.params.tag;
            this.params.status = this.$route.params.params.status;
            this.params.bo_product_category_id = this.$route.params.params.bo_product_category_id;
            this.params.products_sku = this.$route.params.params.product_sku;
            this.products_sku = this.$route.params.params.products_sku;

            // Convert is_comboset from 1/0 to boolean for checkbox
            this.params.is_comboset = this.$route.params.params.is_comboset == 1 ? true : false;

            if (this.products_sku == null) {
                this.products_sku = [];
            }

            this.products_sku.forEach((sku, index) => {
                console.log(sku.wms_map);
                sku.wms_map = JSON.parse(sku.wms_map);
                if (
                    Object.keys(sku.wms_map).length === 0 &&
                    sku.wms_map.constructor === Object
                ) {
                    sku.wms_map = [];
                }
            });
        }
    },
    methods: {
        ...mapActions({
            createData: "Product/createData",
            updateData: "Product/updateData",
            listWMS: "WmsProduct/listData",
            listSkuRandom: "Product/listSkuRandom",
            listProductCategory: "ProductCategory/listData"
        }),
        GetProductName(wms_product_id) {
            let product = this.WmsProductTable.find(s => {
                return s.ID == wms_product_id;
            });
            if (product == undefined) {
                return "";
            } else {
                return product.Name;
            }
        },
        async handleSaveProduct() {
            let valid = await this.$refs.formValidator.validate();
            if (!valid) return;

			// check attributes
			if (this.attributes.length == 0) {
				swal.fire({
					title: this.$t("error"),
					text: "Variable is empty",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}

			//  Check Variable
			valid = true
			await this.attributes.forEach(attr => {
				if (attr.variable == "") {
					swal.fire({
						title: this.$t("error"),
						text: "Variable name is empty",
						icon: "error",
						confirmButtonClass: "btn btn-danger btn-fill",
						buttonsStyling: false
					});
					valid = false
					return;
				}

				if (attr.options.length == 0) {
					swal.fire({
						title: this.$t("error"),
						text: "Variable "+ attr.variable + " options is empty",
						icon: "error",
						confirmButtonClass: "btn btn-danger btn-fill",
						buttonsStyling: false
					});
					valid = false
					return;
				}

				attr.options.forEach(option => {
					if (option.name == "") {
						swal.fire({
							title: this.$t("error"),
							text: "Option name is empty",
							icon: "error",
							confirmButtonClass: "btn btn-danger btn-fill",
							buttonsStyling: false
						});
					valid = false
						return;
					}
				});
			});

			if (!valid) return;

			// Check params string contain .png
			if (this.params.images.includes(".png") || this.params.images.includes(".jpg") || this.params.images.includes(".jpeg")) {
				this.params.images = ""
			}
			
			


            this.params.attributes = this.attributes;

            // Convert is_comboset boolean to 1 or 0
            this.params.is_comboset = this.params.is_comboset ? 1 : 0;

            if (this.params.id == 0) {
                this.createData(this.params)
                    .then(resp => {
                        console.log(resp);
                        swal.fire({
                            title: this.$t("create_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                        this.$router.push({ name: "product" });
                    })
                    .catch(err => {
                        console.log(err);
                        swal.fire({
                            title: err.response.data.Cause,
                            text: "",
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            } else {
                // Update
				if (this.fileNameIsImage(this.params.images)){
					this.params.images = ""
				}
                this.updateData({ id: this.params.id, payload: this.params })
                    .then(resp => {
                        swal.fire({
                            title: this.$t("edit_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                        this.$router.push({ name: "product" });
                    })
                    .catch(err => {
                        swal.fire({
                            title: this.$t(err.response.data.Msg),
                            text: "",
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            }
        },

		// Manage Variable
        handleAddVariable() {
            this.variableName = "";
            this.showAddVariable = true;
        },
        handleUpdateVariable() {
            this.showAddVariable = false;

            this.attributes.push({
                variable: this.variableName,
                options: []
            });
        },
        handleRemoveVariable(index) {
            this.attributes.splice(index, 1);
        },
		handleCopyVariable(index){
			let attribute = JSON.parse(JSON.stringify(this.attributes[index]))
            this.attributes.push(attribute);
		},

		// ManageOption
        handleManageOption(attribute) {
            this.showManageOption = true;
			this.attr = attribute

			this.attr_option = {
				name: "",
				wms_map: []
			}
        },
        handleAddOption() {
			//add new
			this.attr_option.name = this.WmsProductTable.find(s => {
				return s.ID == this.wms_product_id;
			}).ManPN;

			this.attr_option.wms_map = [];
			this.attr_option.wms_map.push({
				wms_product_id: this.wms_product_id,
				wms_product_name: this.WmsProductTable.find(s => {
					return s.ID == this.wms_product_id;
				}).Name,
				pickup_quantity: 1
			})

			this.attr.options.push(JSON.parse(JSON.stringify(this.attr_option)))



        },
		handleAddRandomOption(){
			this.attr_option.name = this.bo_product_random.name
			this.attr_option.wms_map = [];
			this.attr_option.wms_map.push({
				wms_product_id: 0,
				pickup_quantity: 1,
				wms_product_name: this.bo_product_random.name,
				wms_product_random : {
					bo_product_random_id: this.bo_product_random.id,
				}
			})

			this.attr.options.push(JSON.parse(JSON.stringify(this.attr_option)))

		},
        handleRemoveOption(options, index) {
			options.splice(index, 1);
        },
        AddOrUpdateSku(sku_name,wms_map) {
            let sku = this.products_sku.find(s => s.name == sku_name);

            if (sku == undefined) {
                this.products_sku.push({
					id:0,
                    sku_name: sku_name,
                    sku_code: this.params.code + "-" + sku_name,
                    price: this.params.price,
                    image: "",
					quantity:1,
                    wms_map: wms_map
                });
            }
        },
		handleWmsMapChange(){
			// set option name with wms_product_id
			try {
				this.attr_option.name = this.WmsProductTable.find(
					s => s.ID == this.wms_product_id
				).Name;
				console.log(this.attr_option.name)
			}
			catch(err){
				console.log(err)
			}

		},

        handleMapWms(product_sku_index) {
            this.showMapWms = true;
			this.quantity = 1;
            this.product_sku_index = product_sku_index;
        },
        handleAddWmsProduct() {
            let sku = this.products_sku[this.product_sku_index].wms_map.find(
                s => s.wms_product_id == this.wms_product_id
            );

            if (sku == undefined) {
                this.products_sku[this.product_sku_index].wms_map.push({
                    wms_product_id: this.wms_product_id,
                    pickup_quantity: parseInt(this.quantity)
                });
            } else {
                sku.pickup_quantity = parseInt(this.quantity);
            }
        },
		handleAddSkuRandom() {
            let sku = this.products_sku[this.product_sku_index].wms_map.find((s)=>{
				try {
					return s.sku_random_id == this.sku_random_id
				} catch (error) {
					console.log(error)
					return false
				}
			});

            if (sku == undefined) {
                this.products_sku[this.product_sku_index].wms_map.push({
                    wms_product_id: 0,
                    sku_random_id: this.sku_random_id,
                    pickup_quantity: parseInt(this.quantity)
                });
            } else {
                sku.pickup_quantity = parseInt(this.quantity);
            }
        },
        handleRemoveWmsProduct(index) {
            this.products_sku[this.product_sku_index].wms_map.splice(index, 1);
        },

        filesChange(files) {
            if (files[0].type != "image/png" && files[0].type != "image/jpeg") {
                swal.fire({
                    title: "Error",
                    text: "กรุณาเลือกไฟล์รูปภาพ",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }

			console.log(files[0].size)

			if (files[0].size > 1024 * 1024 *2) {
				swal.fire({
                    title: "Error",
                    text: "ขนาดไฟล์รูปภาพต้องไม่เกิน 2 MB",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
			}
            // convert to base64
            const reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onload = () => {
                this.params.images = reader.result;
            };
        },
        SkuFileChange(files) {
			

            if (files[0].type != "image/png" && files[0].type != "image/jpeg") {
                swal.fire({
                    title: "Error",
                    text: "กรุณาเลือกไฟล์รูปภาพ",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }
			console.log(files[0].size)

			if (files[0].size > 1024 * 1024 ) {
				swal.fire({
                    title: "Error",
                    text: "ขนาดไฟล์รูปภาพต้องไม่เกิน 1 MB",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
			}
            // convert to base64
            const reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onload = () => {
                this.products_sku[this.sku_file_index].image = reader.result;
            };
        },
		GetProductUrl(filename){
			return process.env.VUE_APP_API_BASE_URL + "/files/products/" + filename
		},
		fileNameIsImage(filename) {
			return filename.includes(".png") || filename.includes(".jpg") || filename.includes(".jpeg")
		}

    }
};
</script>
